module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm3.c1c334980f496d6380e16caa55b09046.png";